import ymaps from 'ymaps'

export const map = () => {
  const mapContainer = document.querySelector('#map')
  let currentMap

  if (mapContainer) {
    ymaps
      .load('https://api-maps.yandex.ru/2.1/?lang=ru_RU')
      .then((maps) => {
        const map = new maps.Map(mapContainer, {
          center: [55.74648156898261, 37.68261949999996],
          zoom: 16,
          behaviors: [],
          controls: ['zoomControl'],
          suppressMapOpenBlock: true,
          nativeFullscreen: false,
        })

        const placemark = new maps.Placemark(
          [55.74648156898261, 37.68261949999996],
          null,
          {
            iconLayout: 'default#image',
            iconImageHref: 'https://mpgo.ru/upload/custom/map.svg',
            iconImageSize: [110, 117],
            iconImageOffset: [-50, -120],
          }
        )

        map.geoObjects.add(placemark)
      })
      .catch((error) => console.log('Failed to load Yandex Maps', error))
  }
}
